// extracted by mini-css-extract-plugin
export default {"cta":"RG-z","disabled":"SG-z"};